// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"6b640db3","319":"e148453a","453":"54292a4b","455":"a23a817e","728":"d9eba619","977":"6a7f6471"}[chunkId] + ".chunk.js";
};